import { type FC, type PropsWithChildren, type ReactNode } from 'react';

import { Icon, type IconTypes } from '@vakantiesnl/components/src/atoms/Icon';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';

import { useStyles } from './SelectBarContent.styles';

export type SelectBarContentProps = {
	/** Title for the select component */
	title?: ReactNode;
	icon?: IconTypes;
	dataCy?: string;
};

export const SelectBarContent: FC<PropsWithChildren<SelectBarContentProps>> = (props) => {
	const { isDesktop } = useBreakpoints();
	const { classes } = useStyles();
	const { icon, title, dataCy, children } = props;

	return (
		<div className={classes.contentWrapper}>
			<div className={classes.titleWrapper}>
				{icon && <Icon type={icon} size="small" />}
				<Typography variant={isDesktop ? 'labelMd' : 'labelSm'} as="span" data-cy={`${dataCy}-title`}>
					{title}
				</Typography>
			</div>
			{!!children && <div className={classes.childrenWrapper}>{children}</div>}
		</div>
	);
};
